import { ActionTypes } from "@/App/constants/actionTypes";
import { TransmissionTypes } from "@/types";

type SubmitTransmissionTestAction = {
  type: typeof ActionTypes.SUBMIT_TRANSMISSION_TEST;
  payload: TransmissionTypes.TransmissionData;
  formName: string;
};

export const submitTransmissionTest = (payload: TransmissionTypes.TransmissionData, formName: string): SubmitTransmissionTestAction => {
  return {
    type: ActionTypes.SUBMIT_TRANSMISSION_TEST,
    payload,
    formName,
  };
};

type SubmitTransmissionTestResultAction = {
  type: typeof ActionTypes.TRANSMISSION_TEST_RESULT;
  payload: TransmissionTypes.TestClaimRawResponseData;
};

export const submitTransmissionTestResult = (data: TransmissionTypes.TestClaimRawResponseData): SubmitTransmissionTestResultAction => {
  return {
    type: ActionTypes.TRANSMISSION_TEST_RESULT,
    payload: data,
  };
};

export type TransmissionTestActions = SubmitTransmissionTestAction | SubmitTransmissionTestResultAction;
